/**
 * Returns a Promise that resolves after a specified delay.
 *
 * You can use this to either wait for a specific amount of time OR to force a tick
 * of the event loop before executing the next line of code.
 *
 * @example
 * await delay(1000); // Wait for 1 second
 * await delay(); // Force a tick of the event loop
 *
 * @param interval - The delay in milliseconds before the Promise resolves. Defaults to 0ms.
 * @returns A Promise that resolves after the specified interval.
 */

export const delay = (interval: number = 0): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, interval);
  });
